export const SETPROJECTLIST = "SETPROJECTLIST";
export const SETCONTACTPERSONLIST = "SETCONTACTPERSONLIST";
export const CLEARDOC = "CLEARDOC";
export const SETSUBPROJECTLIST = "SETSUBPROJECTLIST";
export const SETSUBPROJECTFILTERLIST = "SETSUBPROJECTFILTERLIST";
export const SETSUBPROJECTDETAIL = "SETSUBPROJECTDETAIL";
export const SETSUBPROJECTSBASICFILTERDATA = "SETSUBPROJECTSBASICFILTERDATA";

